"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finishProjectCreationFailure = exports.finishProjectCreationSuccess = exports.finishProjectCreation = void 0;
const ActionTypes = require("../../../actionTypes/project/wizardSteps/step5");
const finishProjectCreation = (projectId) => ({
    type: ActionTypes.FINISH_PROJECT_CREATION,
    payload: {
        projectId
    }
});
exports.finishProjectCreation = finishProjectCreation;
const finishProjectCreationSuccess = (message) => ({
    type: ActionTypes.FINISH_PROJECT_CREATION_SUCCESS,
    payload: {
        message
    }
});
exports.finishProjectCreationSuccess = finishProjectCreationSuccess;
const finishProjectCreationFailure = (error) => ({
    type: ActionTypes.FINISH_PROJECT_CREATION_FAILURE,
    payload: error
});
exports.finishProjectCreationFailure = finishProjectCreationFailure;
//# sourceMappingURL=step5.js.map